module.exports = __webpack_public_path__ + "img/bu3.980d6dc7.png";